
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30956',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30956",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55533",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8470",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11925",
  "I18n": "static-7.1698",
  "quartz": "static-1.7610",
  "quartz-config": "static-1.1388",
  "quartz-core": "static-1.6829",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1055",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55520",
  "feedback-utils": "static-1.55524",
  "forms-embed-utils-lib": "static-1.4896",
  "forms-utils-lib": "static-1.13270",
  "foundations-assets": "static-1.5319",
  "foundations-components": "static-1.8680",
  "foundations-theming": "static-1.4915",
  "hub-http": "static-1.6642",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12232",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4204",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17167",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5636",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.514",
  "tinymce-plugins": "static-1.58438",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8871",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3887",
  "quartz-webpack": "static-1.3834",
  "foundations-theming-specialty": "static-1.2631",
  "property-description-translator": "static-1.4253",
  "HeadJS": "static-2.816",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3581",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4740",
  "jasmine-runner": "static-1.6884",
  "opentelemetry-fe-types": "static-1.220",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.901",
  "hubspotter-http": "static-1.4946",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.595",
  "quartz-auth": "static-1.1285",
  "quartz-head": "static-1.1275",
  "quartz-i18n": "static-1.1285",
  "quartz-routing": "static-1.1040",
  "quartz-test": "static-1.1285",
  "quartz-tracking": "static-1.989",
  "trellis-components": "static-1-rdeane_hubspot-tooltip-trigger-canary.29",
  "ui-fonts": "static-1.1187",
  "usage-tracker-container": "static-1.7737",
  "usage-tracker-core": "static-1.7597",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.322",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8611",
  "sanitize-text": "static-1.8589",
  "PatternValidationJS": "static-1.3318",
  "ReduxMessenger": "static-2.10804",
  "outpost": "static-1.4566",
  "rpc-client-utils": "static-1.5103",
  "sanitize": "static-1.4906",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4949",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9857",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.96",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1-rdeane_hubspot-tooltip-trigger-canary.29",
  "bend-plugin-foundations-theming": "static-1.3398",
  "foundations-theming-base": "static-1.3900",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.374",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9948",
  "atom": "static-1.5510",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8360",
  "ContentUtils": "static-1.69382",
  "data-token-picker": "static-1.17063",
  "file-manager-components": "static-1.24767",
  "FileManagerCore": "static-1.40266",
  "FileManagerLib": "static-1.40407",
  "frontend-preferences-client": "static-1.8350",
  "hub-http-contrib": "static-1.3461",
  "interframe": "static-3.5173",
  "layout-dnd-components": "static-1.13153",
  "layout-dnd-utils": "static-1.12128",
  "property-translator": "static-1.5812",
  "react-codemirror": "static-1.11072",
  "react-colorpicker": "static-2.10645",
  "reference-resolvers-lite": "static-1.8539",
  "rich-text-lib": "static-1.20491",
  "tinymce-data": "static-1.41409",
  "tinymce-themes": "static-1.57294",
  "ui-addon-emoji-picker": "static-1.10299",
  "ui-addon-sales-email": "static-1.5635",
  "ui-brand-identity-lib": "static-1.16846",
  "bender-build-tools": "static-1.3518",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1419",
  "tanstack-virtual": "static-1.42",
  "stylex-utils": "static-1.166",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.133",
  "hub-http-shared-msw-handlers": "static-1.10832",
  "hubspotter-http-shared-msw-handlers": "static-1.10830",
  "usage-tracker-session-replay": "static-1.5433",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.513",
  "chirp-fetch": "static-1.2334",
  "chatspot-core": "static-1.23598",
  "copilot-toolkit": "static-1.12072",
  "customer-data-objects-ui-components": "static-1.13463",
  "data-fetching-client": "static-1.10078",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5191",
  "ui-addon-video-player": "static-1.9058",
  "ui-coaching-tips": "static-1.29531",
  "usage-tracker": "static-1.7747",
  "cms-field-types": "static-1.5245",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17328",
  "customer-data-objects": "static-1.8126",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2039",
  "apollo-link-hub-http": "static-2.5022",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4573",
  "poll-commands": "static-1.3907",
  "ui-addon-iframeable": "static-1.9509",
  "video-components-external": "static-1.12359",
  "video-data-lib": "static-1.36017",
  "breeze-artifacts-sdk": "static-1.749",
  "audio-components": "static-1.6510",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29997",
  "FileManagerImages": "static-1.37918",
  "foundations-components-legacy": "static-1.1705",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.689",
  "ui-universal-auth": "static-1.9647",
  "urlinator": "static-1.4948",
  "video-components": "static-1.14361",
  "video-embed": "static-1.36851",
  "ts-schema": "static-1.4374",
  "ContentData": "static-1.69457",
  "layout-data-lib": "static-1.10453",
  "react-dnd-compat": "static-1.5043",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1979",
  "external-options-client-types": "static-1.4423",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6022",
  "hs-resources": "static-1.630",
  "inbound-db-properties-service-client": "static-1.4123",
  "NamespacedHubStyle": "static-2.9339",
  "growth-onboarding-confetti": "static-1.3495",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11578",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5869",
  "magpie-types": "static-1.5329",
  "simple-logging-lib": "static-1.3484",
  "avatar-components": "static-1.2917",
  "customer-data-ui-utilities": "static-1.10266",
  "growth-onboarding-feedback-components": "static-1.7015",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5311",
  "integrations-error-boundary-lib": "static-1.14743",
  "integrations-tracking-lib": "static-1.6045",
  "laboratory-lib": "static-3.7583",
  "native-integrations-shared-strings": "static-1.8195",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10708",
  "unified-auth": "static-1.1161",
  "breeze-engine-chat-components": "static-1.1017",
  "breeze-engine-core": "static-1.1317",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1074",
  "navigation-messaging": "static-1.8414",
  "content-media-composition-data-lib": "static-1.13513",
  "content-media-compositions": "static-2.17520",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19581",
  "nudge-client-utils": "static-1.3345",
  "unified-auth-core-lib": "static-1.1443",
  "social-insights-client-types": "static-1.22866",
  "advanced-menus-core": "static-1.15749",
  "advanced-menus-lib": "static-1.12515",
  "ExportDialog": "static-6.10804",
  "ui-memberships-settings-lib": "static-1.35106",
  "conditional-properties-service-client": "static-1.4094",
  "crm-pipelines-api-client-types": "static-1.4425",
  "event-emitter": "static-1.1393",
  "framework-builder-read-service-client": "static-1.4305",
  "fdsr-migration-layer": "static-1.444",
  "inbound-db-meta-service-client": "static-1.3752",
  "multi-currency-client-types": "static-1.3990",
  "foundations-components-test-utils": "static-1.6163",
  "reactive-lib": "static-1.1156",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.770",
  "universal-page-editor-lib": "static-1.3441",
  "adobe-sign-auth-lib": "static-1.691",
  "ads-unified-auth-lib": "static-1.1820",
  "custom-vendor-connection-lib": "static-1.211",
  "google-sheets-integration-lib": "static-1.1259",
  "microsoft-drive-auth-lib": "static-1.419",
  "surveymonkey-integration-lib": "static-1.786",
  "slack-ui-library": "static-1.10829",
  "bend-plugin-pulse": "static-1.577",
  "fast-json-patch": "static-1.73",
  "nav-meta": "static-1.30724",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3102",
  "nudge-renderer-utils": "static-1.3421",
  "onboarding-tours": "static-1.17333",
  "whisper-core-api": "static-1.7567",
  "fsm": "static-1.4189",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15748",
  "simple-menus-lib": "static-1.17265",
  "settings-ui-lib": "static-1.12963",
  "persist-promise": "static-1.4136",
  "crm-record-cards-service-types": "static-1.3844",
  "framework-data-schema-resolvers": "static-1.7325",
  "location-customization-utils-lib": "static-1.10345",
  "getting-started-shared-tasks": "static-1.19489",
  "growth-data-modal": "static-1.6070",
  "growth-onboarding-next-action-utils": "static-1.2913",
  "navigation-components": "static-1.19087",
  "onboarding-tours-client": "static-1.5548",
  "onboarding-tours-utils": "static-1.1400",
  "ui-shepherd-tracker": "static-1.8089",
  "user-context": "static-1.5484",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7230",
  "onboarding-data-sync-lib": "static-1.2776",
  "growth-onboarding-next-action-components": "static-1.2941",
  "user-context-client": "static-1.4942",
  "nest": "static-1.668",
  "getting-started-shared-tasks-store": "static-1.18607",
  "InboxConnectUtils": "static-4.15774",
  "meetings-connect-utils-lib": "static-1.8049",
  "onboarding-scopes": "static-1.6886"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30956",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55533",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8470",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11925",
  "I18n": "/I18n/static-7.1698",
  "quartz": "/quartz/static-1.7610",
  "quartz-config": "/quartz-config/static-1.1388",
  "quartz-core": "/quartz-core/static-1.6829",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1055",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55520",
  "feedback-utils": "/feedback-utils/static-1.55524",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4896",
  "forms-utils-lib": "/forms-utils-lib/static-1.13270",
  "foundations-assets": "/foundations-assets/static-1.5319",
  "foundations-components": "/foundations-components/static-1.8680",
  "foundations-theming": "/foundations-theming/static-1.4915",
  "hub-http": "/hub-http/static-1.6642",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12232",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4204",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17167",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5636",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "tinymce-plugins": "/tinymce-plugins/static-1.58438",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8871",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3887",
  "quartz-webpack": "/quartz-webpack/static-1.3834",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2631",
  "property-description-translator": "/property-description-translator/static-1.4253",
  "HeadJS": "/HeadJS/static-2.816",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3581",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4740",
  "jasmine-runner": "/jasmine-runner/static-1.6884",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.220",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hubspotter-http": "/hubspotter-http/static-1.4946",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.595",
  "quartz-auth": "/quartz-auth/static-1.1285",
  "quartz-head": "/quartz-head/static-1.1275",
  "quartz-i18n": "/quartz-i18n/static-1.1285",
  "quartz-routing": "/quartz-routing/static-1.1040",
  "quartz-test": "/quartz-test/static-1.1285",
  "quartz-tracking": "/quartz-tracking/static-1.989",
  "trellis-components": "/trellis-components/static-1-rdeane_hubspot-tooltip-trigger-canary.29",
  "ui-fonts": "/ui-fonts/static-1.1187",
  "usage-tracker-container": "/usage-tracker-container/static-1.7737",
  "usage-tracker-core": "/usage-tracker-core/static-1.7597",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.322",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8611",
  "sanitize-text": "/sanitize-text/static-1.8589",
  "PatternValidationJS": "/PatternValidationJS/static-1.3318",
  "ReduxMessenger": "/ReduxMessenger/static-2.10804",
  "outpost": "/outpost/static-1.4566",
  "rpc-client-utils": "/rpc-client-utils/static-1.5103",
  "sanitize": "/sanitize/static-1.4906",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4949",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9857",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.96",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1-rdeane_hubspot-tooltip-trigger-canary.29",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3398",
  "foundations-theming-base": "/foundations-theming-base/static-1.3900",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.374",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9948",
  "atom": "/atom/static-1.5510",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8360",
  "ContentUtils": "/ContentUtils/static-1.69382",
  "data-token-picker": "/data-token-picker/static-1.17063",
  "file-manager-components": "/file-manager-components/static-1.24767",
  "FileManagerCore": "/FileManagerCore/static-1.40266",
  "FileManagerLib": "/FileManagerLib/static-1.40407",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8350",
  "hub-http-contrib": "/hub-http-contrib/static-1.3461",
  "interframe": "/interframe/static-3.5173",
  "layout-dnd-components": "/layout-dnd-components/static-1.13153",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12128",
  "property-translator": "/property-translator/static-1.5812",
  "react-codemirror": "/react-codemirror/static-1.11072",
  "react-colorpicker": "/react-colorpicker/static-2.10645",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8539",
  "rich-text-lib": "/rich-text-lib/static-1.20491",
  "tinymce-data": "/tinymce-data/static-1.41409",
  "tinymce-themes": "/tinymce-themes/static-1.57294",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10299",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5635",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16846",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1419",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "stylex-utils": "/stylex-utils/static-1.166",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.133",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10832",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10830",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5433",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.513",
  "chirp-fetch": "/chirp-fetch/static-1.2334",
  "chatspot-core": "/chatspot-core/static-1.23598",
  "copilot-toolkit": "/copilot-toolkit/static-1.12072",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13463",
  "data-fetching-client": "/data-fetching-client/static-1.10078",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5191",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9058",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29531",
  "usage-tracker": "/usage-tracker/static-1.7747",
  "cms-field-types": "/cms-field-types/static-1.5245",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17328",
  "customer-data-objects": "/customer-data-objects/static-1.8126",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2039",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4573",
  "poll-commands": "/poll-commands/static-1.3907",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9509",
  "video-components-external": "/video-components-external/static-1.12359",
  "video-data-lib": "/video-data-lib/static-1.36017",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.749",
  "audio-components": "/audio-components/static-1.6510",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29997",
  "FileManagerImages": "/FileManagerImages/static-1.37918",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1705",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.689",
  "ui-universal-auth": "/ui-universal-auth/static-1.9647",
  "urlinator": "/urlinator/static-1.4948",
  "video-components": "/video-components/static-1.14361",
  "video-embed": "/video-embed/static-1.36851",
  "ts-schema": "/ts-schema/static-1.4374",
  "ContentData": "/ContentData/static-1.69457",
  "layout-data-lib": "/layout-data-lib/static-1.10453",
  "react-dnd-compat": "/react-dnd-compat/static-1.5043",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1979",
  "external-options-client-types": "/external-options-client-types/static-1.4423",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6022",
  "hs-resources": "/hs-resources/static-1.630",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4123",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9339",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3495",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11578",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5869",
  "magpie-types": "/magpie-types/static-1.5329",
  "simple-logging-lib": "/simple-logging-lib/static-1.3484",
  "avatar-components": "/avatar-components/static-1.2917",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10266",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7015",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5311",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14743",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6045",
  "laboratory-lib": "/laboratory-lib/static-3.7583",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8195",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10708",
  "unified-auth": "/unified-auth/static-1.1161",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1017",
  "breeze-engine-core": "/breeze-engine-core/static-1.1317",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1074",
  "navigation-messaging": "/navigation-messaging/static-1.8414",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13513",
  "content-media-compositions": "/content-media-compositions/static-2.17520",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19581",
  "nudge-client-utils": "/nudge-client-utils/static-1.3345",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1443",
  "social-insights-client-types": "/social-insights-client-types/static-1.22866",
  "advanced-menus-core": "/advanced-menus-core/static-1.15749",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12515",
  "ExportDialog": "/ExportDialog/static-6.10804",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35106",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4094",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4425",
  "event-emitter": "/event-emitter/static-1.1393",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4305",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.444",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3752",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3990",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6163",
  "reactive-lib": "/reactive-lib/static-1.1156",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.770",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3441",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.691",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1820",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.211",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1259",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.419",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.786",
  "slack-ui-library": "/slack-ui-library/static-1.10829",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.577",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "nav-meta": "/nav-meta/static-1.30724",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3102",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3421",
  "onboarding-tours": "/onboarding-tours/static-1.17333",
  "whisper-core-api": "/whisper-core-api/static-1.7567",
  "fsm": "/fsm/static-1.4189",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15748",
  "simple-menus-lib": "/simple-menus-lib/static-1.17265",
  "settings-ui-lib": "/settings-ui-lib/static-1.12963",
  "persist-promise": "/persist-promise/static-1.4136",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3844",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7325",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10345",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19489",
  "growth-data-modal": "/growth-data-modal/static-1.6070",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2913",
  "navigation-components": "/navigation-components/static-1.19087",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5548",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1400",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8089",
  "user-context": "/user-context/static-1.5484",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7230",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2776",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2941",
  "user-context-client": "/user-context-client/static-1.4942",
  "nest": "/nest/static-1.668",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18607",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15774",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8049",
  "onboarding-scopes": "/onboarding-scopes/static-1.6886"
}
};
